import { useMutation, useQuery } from "@tanstack/react-query";
import { api } from "api";
import axios, { AxiosError } from "axios";
import { T_Api_Paginated, T_Api_Success_Res } from "./api.types";
import { ConsumptionTypes, CreditTypes, LogsType } from "dtos/credit.dto";

export const creditService = {
  useGetMetrics: () => {
    return useQuery({
      queryKey: ["credits/metrics"],
      queryFn: async () => {
        const res = await api.get(`/credit/metrics`);
        return res.data as T_Api_Success_Res<
          { title: string; amount: number; used: number; overdue: number; extras: any }[]
        >;
      },
    });
  },
  useGetLogs: (
    type: CreditTypes,
    filters: {
      page: number;
      limit: number;
      startDate?: string;
      endDate?: string;
      consumptionType?: ConsumptionTypes;
      sortOrder?: "asc" | "desc";
    },
  ) => {
    return useQuery({
      queryKey: ["credits/logs", type, filters],
      queryFn: async () => {
        const queryParams = new URLSearchParams({
          page: filters.page.toString(),
          limit: filters.limit.toString(),
        });

        if (filters.startDate) queryParams.append("startDate", filters.startDate);
        if (filters.endDate) queryParams.append("endDate", filters.endDate);
        if (filters.consumptionType) queryParams.append("consumptionType", filters.consumptionType);

        if (filters.sortOrder) queryParams.append("sortOrder", filters.sortOrder === "asc" ? "1" : "-1");

        const res = await api.get(`/credit/logs?type=${type}&${queryParams.toString()}`);
        return res.data as T_Api_Success_Res<T_Api_Paginated<LogsType>>;
      },
    });
  },

  useConsumeCredits: () => {
    return useMutation({
      mutationKey: ["credits", "consume"],
      mutationFn: async (body: {
        appkey?: string;
        credit_type: CreditTypes;
        description?: string;
        amount: number;
        extra?: object;
      }) => {
        const res = await api.post(`/credit/consume`, body);
      },
    });
  },

  useRechargeCredits: () => {
    return useMutation({
      mutationKey: ["credits", "recharge"],
      mutationFn: async (body: {
        id: string;
        amount: number;
        payment: number;
        description?: string;
        user?: string;
        application?: string;
      }) => {
        const res = await api.post(`/credit/recharge`, body);
      },
    });
  },

  useGetCreditModels: () => {
    return useQuery({
      queryKey: ["credits/models"],
      queryFn: async () => {
        const res = await api.get(`/credit/models`);
        return res.data as T_Api_Success_Res<{ title: CreditTypes; value: string }[]>;
      },
    });
  },
};
